import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { NotificationContainer } from '@/components/ui/NotificationContainer';

/** Routes that need full-width, edge-to-edge layout (no container padding) */
const FULL_WIDTH_ROUTES = ['/location-tracking'];

export const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const isFullWidth = FULL_WIDTH_ROUTES.some(r => location.pathname.startsWith(r));

  return (
    <div className="flex h-screen bg-rgf-gray-50">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      {/* Main content */}
      <div className={clsx(
        'flex-1 flex flex-col transition-all duration-300 ease-in-out',
        sidebarOpen ? 'ml-64' : 'ml-0'
      )}>
        {/* Header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        
        {/* Page content */}
        <main className="flex-1 overflow-auto">
          {isFullWidth ? (
            <Outlet />
          ) : (
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <Outlet />
            </div>
          )}
        </main>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Notification Container */}
      <NotificationContainer />
    </div>
  );
};